import { Link } from "react-router-dom";
import { ShieldCheck, Mail, Phone } from "lucide-react";
import { SITE } from "@/lib/site";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="relative border-t border-black/[0.08] bg-[#ede4d3]">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-3">
            <span className="w-9 h-9 rounded-full flex items-center justify-center bg-gradient-to-br from-[#ffffff] via-[#2b2620] to-[#6b6c75] text-white">
              <ShieldCheck className="w-5 h-5" strokeWidth={2.2} />
            </span>
            <div>
              <div className="font-heading text-base font-semibold text-[#2b2620]">{SITE.brand}</div>
              <div className="text-[11px] uppercase tracking-[0.18em] text-[#2b2620]/80">Reputationsmanagement</div>
            </div>
          </div>
          <p className="mt-5 text-sm text-[#6b5f52] leading-relaxed max-w-md">
            Ich unterstütze Unternehmen beim strukturierten Meldeprozess von Online-Bewertungen über die offiziellen Plattformwege. Die Entscheidung über eine Entfernung liegt immer bei der jeweiligen Plattform.
          </p>
          <div className="mt-6 space-y-2 text-sm">
            <a
              href={SITE.whatsapp}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => {
                if (typeof window === "undefined") return;
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({ event: "whatsapp_click", source: "footer" });
                if (typeof window.gtag === "function") {
                  window.gtag("event", "conversion", { send_to: "AW-16867023480/7Cp6CKy784ocEPi06eo-" });
                }
              }}
              data-conversion="whatsapp_click"
              className="flex items-center gap-2 text-[#4a3f36] hover:text-[#2b2620]"
            >
              <Phone className="w-4 h-4" /> {SITE.phone}
            </a>
            <a href={`mailto:${SITE.email}`} className="flex items-center gap-2 text-[#4a3f36] hover:text-[#2b2620]">
              <Mail className="w-4 h-4" /> {SITE.email}
            </a>
          </div>
        </div>

        <div>
          <div className="text-xs uppercase tracking-[0.18em] text-[#8a7f70] mb-4">Navigation</div>
          <ul className="space-y-2.5 text-sm">
            <li><a href="#leistung" className="text-[#4a3f36] hover:text-[#2b2620]">Leistung</a></li>
            <li><a href="#ablauf" className="text-[#4a3f36] hover:text-[#2b2620]">Ablauf</a></li>
            <li><a href="#preise" className="text-[#4a3f36] hover:text-[#2b2620]">Preise</a></li>
            <li><a href="#faq" className="text-[#4a3f36] hover:text-[#2b2620]">FAQ</a></li>
            <li><a href="#kontakt" className="text-[#4a3f36] hover:text-[#2b2620]">Kontakt</a></li>
          </ul>
        </div>

        <div>
          <div className="text-xs uppercase tracking-[0.18em] text-[#8a7f70] mb-4">Rechtliches</div>
          <ul className="space-y-2.5 text-sm">
            <li><Link to="/impressum" data-testid="footer-impressum" className="text-[#4a3f36] hover:text-[#2b2620]">Impressum</Link></li>
            <li><Link to="/datenschutz" data-testid="footer-datenschutz" className="text-[#4a3f36] hover:text-[#2b2620]">Datenschutz</Link></li>
            <li><Link to="/agb" data-testid="footer-agb" className="text-[#4a3f36] hover:text-[#2b2620]">AGB</Link></li>
            <li><Link to="/widerrufsrecht" data-testid="footer-widerruf" className="text-[#4a3f36] hover:text-[#2b2620]">Widerrufsrecht</Link></li>
          </ul>
          <div className="mt-6 text-xs uppercase tracking-[0.18em] text-[#8a7f70] mb-3">Schwesterseiten</div>
          <ul className="space-y-2 text-sm">
            <li><a href={SITE.sister.in7} target="_blank" rel="noopener noreferrer" className="text-[#4a3f36] hover:text-[#2b2620]">in7sekunden.de</a></li>
            <li><a href={SITE.sister.femmes} target="_blank" rel="noopener noreferrer" className="text-[#4a3f36] hover:text-[#2b2620]">femmesonlinebusiness.com</a></li>
          </ul>
        </div>
      </div>

      <div className="border-t border-black/[0.05]">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <div className="text-xs text-[#8a7f70] text-center sm:text-left">
            © {new Date().getFullYear()} {SITE.brand} – {SITE.tagline}. Alle Rechte vorbehalten.
          </div>
          <div className="text-xs text-[#9b9ca5] text-center sm:text-right max-w-2xl">
            Diese Dienstleistung stellt keine Rechtsberatung dar und ersetzt nicht die Konsultation eines Fachanwalts.
          </div>
        </div>
      </div>
    </footer>
  );
}
